<template>
    <div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3 nopad">
            <side :ranks="ranks"></side>
            <audio controls>
              <source src="http://deinesv.cf/silence.mp3" type="audio/mpeg">
            </audio>
            
            <button @click="fullscreen">abc</button>
          </div>

          <div class="col-md-9 content">
            <div class="">
              <div class="row">
                <div class="col-md-12 bg-white">
                  <top-c-v-header></top-c-v-header>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5">
                  <shadow-box>
                    <calendar></calendar>
                  </shadow-box>
                </div>
                <div class="col-md-7">
                  <shadow-box :className="'bg-gra'">
                      <weather></weather>
                  </shadow-box>
                  <shadow-box>
                    <user-statistic :candidateNo="candidateNo" :employerNo="employerNo"></user-statistic>
                  </shadow-box>
                </div>
              </div>
              <div class="row row-eq-height">
                <div class="col-md-5">
                  <shadow-box>

                    <birthday v-if="birthdays.length != 0" :birthdays="birthdays"></birthday>
                    <quote :quote="quote"></quote>
                  </shadow-box>
                </div>
                <div class="col-md-7">
                  <shadow-box>
                    <check-in :qr="qr"></check-in>
                  </shadow-box>
                </div>
                 

              </div>
            
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Calendar from '@/components/Calendar'
import Weather from '@/components/Weather'
import UserStatistic from '@/components/UserStatistic'
import Birthday from '@/components/Birthday'
import CheckIn from '@/components/CheckIn'
import Side from '@/components/Side'
import TopCVHeader from '@/components/TopCVHeader'
import ShadowBox from '@/components/ShadowBox'
import moment from 'moment';
import Quote from '@/components/Quote.vue';

import {getQrApi,getBirthdayApi,getUserStatisticApi, getRankingApi} from '@/api/api'
export default {
  name: 'Dashboard',
  components: { Calendar, Weather, UserStatistic, Birthday, CheckIn, Side,TopCVHeader, ShadowBox, Quote},
  data () {
    return {
      baseUrl: 'http://dktt.topcv.local',
      employerNo: 10000,
      candidateNo: 80000,
      qr:'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/220px-QR_code_for_mobile_English_Wikipedia.svg.png',
      birthdays:[],
      ranks:[],
      quote: 'Đừng so sánh mình với bất cứ ai trong thế giới này. Nếu bạn làm như vậy có nghĩa bạn đang sỉ nhục chính bản thân mình.'
    }
    
  },
  methods: {
    getQrCode(){
      getQrApi().done((rs)=>{
        this.qr = rs.data.qr; 
      });

    },
    getBirthday(){
      getBirthdayApi().done((rs)=>{
        this.birthdays = rs.data.haveBirthdayUsers; 
      });
    },
    getUserStatistic(){
      getUserStatisticApi().done((rs)=>{
        this.candidateNo = rs.data.candidate_count; 
        this.employerNo = rs.data.employer_count; 
      });
    },
    getRanking(){
      getRankingApi().done((rs)=>{
        this.ranks = rs.data;
      });
    },
    fullscreen(){
      var elem = document.documentElement;
        elem.webkitRequestFullscreen();
    }
  },
  mounted () {
        
        this.getQrCode();
        this.getBirthday();
        this.getUserStatistic();
        this.getRanking();
        var channel = this.$pusher.subscribe('dashboard');
        channel.bind('qr-check', ( log ) => {
            this.getQrCode();
            console.log(log);
            if (log.type == 'checkin') {
              this.$awn.success("Chúc " + log.user.fullname + ' có một ngày làm việc hiệu quả');
            } else {
              this.$awn.success("Chào tạm biệt " + log.user.fullname );
            }
            let thankAudio = new Audio('../assets/thank.mp3');
            thankAudio.play();
            // alert('Check in thành công');
        });
    },
  created(){
      setInterval(()=>{
        // console.log(moment().format('HH'));
        if( moment().format('HH') >= 17 ) {
            this.$router.push({ path: 'checkout' })
        }
      }, 1000);
      // this.$awn.success("Your custom message")
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Dashboard.vue